import React, {useState} from "react";
import MainSearchSection from "./components/MainSearchSection";
import MainSection from "./components/MainSection";
import FooterSection from "./components/FooterSection";
import Navbar from "./components/Navbar";
import LoginModal from "../../../components/LoginModal";

const MainPage = (props) => {
  const [showModal, setShowModal] = useState(null);
  return (
    <>
      <Navbar setShowModal={setShowModal}/>
      <MainSearchSection />
      <MainSection />
      <FooterSection />
      <LoginModal {...props} fromHomePublic={true} open={showModal} onClose={() => setShowModal(!showModal)}></LoginModal>
    </>
  );
};

export default MainPage;
